module.exports = __webpack_public_path__ + "static/media/apple-wallet.504773e1.png";